import { LINKEDIN, META } from "./adsPlatformIds.js";
import {
  buildInstantFormPreview,
  hasInstantFormPreviewContent,
  mergeMetaInstantFormPreviewStorageFields,
  pickMetaInstantFormPreviewStorageFields,
  resolveInstantFormPreviewSource,
} from "./instantFormPreview.js";
import {
  buildLinkedInLeadFormPreview,
  hasLinkedInLeadFormPreviewContent,
  mergeLinkedInLeadFormPreviewStorageFields,
  pickLinkedInLeadFormPreviewStorageFields,
  resolveLinkedInLeadFormPreviewSource,
} from "./linkedInLeadFormPreview.js";

export const pickLeadFormPreviewStorageFields = (platform, source) => {
  if (platform === LINKEDIN) {
    return pickLinkedInLeadFormPreviewStorageFields(source);
  }
  if (platform === META) {
    return pickMetaInstantFormPreviewStorageFields(source);
  }
  return {};
};

export const mergeLeadFormPreviewStorageFields = (
  platform,
  form,
  recommendation
) => {
  if (platform === LINKEDIN) {
    return mergeLinkedInLeadFormPreviewStorageFields(form, recommendation);
  }
  if (platform === META) {
    return mergeMetaInstantFormPreviewStorageFields(form, recommendation);
  }
  return {};
};

export const resolveLeadFormPreviewSource = (
  platform,
  form,
  recommendation
) => {
  if (platform === LINKEDIN) {
    return resolveLinkedInLeadFormPreviewSource(form, recommendation);
  }
  if (platform === META) {
    return resolveInstantFormPreviewSource(form, recommendation);
  }
  return null;
};

export const buildLeadFormPreview = (platform, source, options) => {
  if (platform === LINKEDIN) {
    return buildLinkedInLeadFormPreview(source, options);
  }
  if (platform === META) {
    return buildInstantFormPreview(source, options);
  }
  return {
    title: "",
    description: "",
    contactFields: [],
    moreCount: 0,
  };
};

export const hasLeadFormPreviewContent = (platform, preview) => {
  if (platform === LINKEDIN) {
    return hasLinkedInLeadFormPreviewContent(preview);
  }
  if (platform === META) {
    return hasInstantFormPreviewContent(preview);
  }
  return false;
};
